var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 37.6292C34.8332 59.3632 66.978 50.0486 74.305 37.6292C75.383 35.8024 75.9998 33.6816 75.9998 31.4194C75.9998 24.5603 70.329 19 63.3332 19C56.3376 19 50.6665 24.5603 50.6665 31.4194",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 37.6292C34.8332 59.3632 66.978 50.0486 74.305 37.6292C75.383 35.8024 75.9998 33.6816 75.9998 31.4194C75.9998 24.5603 70.329 19 63.3332 19C56.3376 19 50.6665 24.5603 50.6665 31.4194",
    stroke: "url(#paint0_linear_16725_957)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.667 56.5449C107.667 46.3028 114.756 38 123.5 38C132.245 38 139.333 46.3028 139.333 56.5449C139.333 61.0863 137.94 65.2466 135.626 68.4703C122.527 89.8795 58.7507 81.8039 25.3335 75.0899",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.667 56.5449C107.667 46.3028 114.756 38 123.5 38C132.245 38 139.333 46.3028 139.333 56.5449C139.333 61.0863 137.94 65.2466 135.626 68.4703C122.527 89.8795 58.7507 81.8039 25.3335 75.0899",
    stroke: "url(#paint1_linear_16725_957)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.874 125.953C84.1781 130.059 87.6969 133 91.8332 133C97.0797 133 101.333 128.268 101.333 122.43C101.333 120.445 100.842 118.588 99.9861 117.001C91.8325 101.286 50.6663 90.7179 12.6665 118.906",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.874 125.953C84.1781 130.059 87.6969 133 91.8332 133C97.0797 133 101.333 128.268 101.333 122.43C101.333 120.445 100.842 118.588 99.9861 117.001C91.8325 101.286 50.6663 90.7179 12.6665 118.906",
    stroke: "url(#paint2_linear_16725_957)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 98.1667H133",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 98.1667H133",
    stroke: "url(#paint3_linear_16725_957)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_957",
    x1: 12.6665,
    y1: 19,
    x2: 74.1044,
    y2: 53.9944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_957",
    x1: 25.3335,
    y1: 38,
    x2: 120.67,
    y2: 107.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_957",
    x1: 12.6665,
    y1: 101.333,
    x2: 82.3036,
    y2: 156.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_957",
    x1: 120.333,
    y1: 98.1667,
    x2: 121.495,
    y2: 102.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/AC.980d9d3944bd7a7d73b8a4111cc9377c.svg";
export { ForwardRef as ReactComponent };